import types from '../mutation-types';
import AuthAPI from '../../api/auth';

const state = {
  unreadCount: 0,
};

export const getters = {
  getUnreadCount: $state => $state.unreadCount,
};

export const actions = {
  fetch: async ({ commit }) => {
    try {
      const response = await AuthAPI.getMessageUnreadCount();
      const { unread_count: unreadCount } = response.data;
      commit(types.SET_USER_UNREAD_COUNT, unreadCount);
    } catch (error) {
      // Ignore error
    }
  },
  set({ commit }, unreadCount) {
    commit(types.SET_USER_UNREAD_COUNT, unreadCount);
  },
};

export const mutations = {
  [types.SET_USER_UNREAD_COUNT]($state, unreadCount) {
    $state.unreadCount = unreadCount || 0;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
